module.exports = __webpack_public_path__ + "img/mobile-nav-facebook.fcc3b07e.svg";